export default __webpack_public_path__ + "static/media/male.af503f61.png";